import React from "react";
import styled from "styled-components";
import { Menu, Row, Col } from "antd";
import { NavLink } from "react-router-dom";

const StyledNavLink = styled(NavLink)`
  span {
    color: #061a32;
  }
  svg path,
  svg circle,
  svg rect,
  svg polygon,
  svg polyline,
  svg line {
    stroke: #061a32;
  }
  &.active {
    span {
      color: #386ee8;
    }
    svg path,
    svg circle,
    svg rect,
    svg polygon,
    svg polyline,
    svg line {
      stroke: #386ee8;
    }
  }
  :hover {
    span {
      color: #386ee8;
    }
    svg path,
    svg circle,
    svg rect,
    svg polygon,
    svg polyline,
    svg line {
      stroke: #386ee8;
    }
  }
`;

const CompactMenuItem = styled(Menu.Item)`
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer;
  svg {
    width: 100%;
  }
  // :hover {
  //   span {
  //     color: #386ee8;
  //   }
  //   svg path,
  //   svg circle,
  //   svg rect,
  //   svg polygon,
  //   svg polyline,
  //   svg line {
  //     stroke: #386ee8;
  //   }
  // }
`;

type Props = {
  icon: React.ReactElement;
  title: string;
  path: string;
};

const MenuItemTitle = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #061a32;
`;

export const ForwardMenuItem: React.FC<Props> = props => {
  const { icon, title, path } = props;
  return (
    <CompactMenuItem>
      <StyledNavLink
        to={path}
        onClick={() => (document.body.style.overflow = "unset")}
        exact={true}
      >
        <Row
          type="flex"
          justify="start"
          align="middle"
          style={{ height: "52px" }}
        >
          <div style={{ width: "36px" }}>{icon}</div>
          <Col style={{ paddingLeft: "20px" }}>
            <MenuItemTitle>{title}</MenuItemTitle>
          </Col>
        </Row>
      </StyledNavLink>
    </CompactMenuItem>
  );
};
